import { render, staticRenderFns } from "./LandingPassengersDataRegisterDialog.vue?vue&type=template&id=6de72806&"
import script from "./LandingPassengersDataRegisterDialog.vue?vue&type=script&lang=js&"
export * from "./LandingPassengersDataRegisterDialog.vue?vue&type=script&lang=js&"
import style0 from "./LandingPassengersDataRegisterDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de72806')) {
      api.createRecord('6de72806', component.options)
    } else {
      api.reload('6de72806', component.options)
    }
    module.hot.accept("./LandingPassengersDataRegisterDialog.vue?vue&type=template&id=6de72806&", function () {
      api.rerender('6de72806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/data/landingPassengersData/LandingPassengersDataRegisterDialog.vue"
export default component.exports